import fp from 'lodash/fp';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { compose } from 'redux';
import { routes } from '../../../../../constants';
import { Icon } from '../../../../components';
import QualificationTile from './qualification-tile';

const Qualifications = ({ businessId, userId, userQualifications, businessUserQualifications }) => {
  const disableEdit = !!userId && !!businessId
  const qualifications = (disableEdit ? businessUserQualifications : userQualifications) || []
  return <div className='profile--qualifications'>
    <Row className='no-gutter'>
      <Col xs={12} md={9}>
        <h2>
          <Icon icon='content-large' />{`Qualifications & Documents`}
        </h2>
      </Col>
      {
        disableEdit ? null :
          <Col xs={12} md={3}>
            <LinkContainer className='full' to={routes.app.professionalProfile.qualificationDetail}>
              <Button>Add Documents +</Button>
            </LinkContainer>
          </Col>
      }
    </Row>
    <Row className='no-gutter'>
      <Col xs={12}>
        <p className='no-margin'>Upload your professional qualifications and documents here so you can easily access them in the one place</p>
      </Col>
    </Row>

    <div id='qualification-list'>
      {
        qualifications.length > 0 ?
          fp.map(
            (qualification) => {
              const nextRoute = disableEdit ?
                routes.app.professionalProfile.businessUserQualificationDetail(businessId, userId, qualification.id) :
                routes.app.professionalProfile.qualificationEdit(qualification.id)
              return <QualificationTile nextRoute={nextRoute} key={qualification.id} qualification={qualification} />
            }
          )(qualifications) :
          disableEdit ?
            <h4>No qualifications or documents have been uploaded yet</h4> :
            null
      }
    </div>
  </div>
}

const mapStateToProps = (state) => ({
  userQualifications: state.user.qualifications,
  businessUserQualifications: state.business.user.qualifications
})
const mapDispatchToProps = (dispatch) => ({
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(Qualifications)


// WEBPACK FOOTER //
// ./src/containers/pages/app/professional-profile/qualifications/qualifications.js